import { render, staticRenderFns } from "./SinglePost.vue?vue&type=template&id=b270a974&scoped=true"
import script from "./SinglePost.vue?vue&type=script&lang=js"
export * from "./SinglePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b270a974",
  null
  
)

export default component.exports